import { Pipe, PipeTransform } from '@angular/core';
import { EXCLUSION_LABEL_MAP } from '../components/search-query-form/search-query-form.constants';
import { ExclusionType } from '../components/search-query-form/search-query-form.models';

@Pipe({
  name: 'exclusionLabel',
})
export class ExclusionLabelPipe implements PipeTransform {
  transform(value: ExclusionType[]): string {
    const [first, ...rest] = value;

    return [
      EXCLUSION_LABEL_MAP[first],
      rest.length ? `(+${rest.length} other${rest.length > 1 ? 's' : ''})` : '',
    ]
      .filter(Boolean)
      .join(' ');
  }
}
